module.exports = __webpack_public_path__ + "media/huong-dan-add-content.d5c837ab.mp4";